import React, { useState, useEffect, useRef } from "react";
import axios from "../axios";
import * as moment from "moment";
import ClipLoader from "react-spinners/ClipLoader";
import { NotificationManager } from "react-notifications";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { registerLicense } from "@syncfusion/ej2-base";


registerLicense(
  "ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5RdEVjXntdcHNVQGda;MzExNjY5OUAzMjM0MmUzMDJlMzBFZmo4T0hTeUlZQjB3cjhSVFkvT0tLUDFUVEtMZU9NQXljVHk3dXloYnJ3PQ=="
);

export const Export = () => {
  let date = moment(new Date());
  console.log(date);

  const [endDate, setEndDate] = useState(
    new Date(date.add(0, "day").valueOf())
  );

  const [startDate, setStartDate] = useState(
    new Date(date.subtract(1, "week").valueOf())
  );
  const [dates1, setDates1] = useState("");
  const [dates2, setDates2] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [response, setResponse] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);
  // const [noPatients, setNoPatients] = React.useState(false);
  const [showButton, setShowButton] = React.useState(false);
  const [contentType,setContentType] =React.useState('')
  const [data,setData]= React.useState(null)
  const dateRangePickerRef = useRef(null);
  const handleRangeSelected = (args) => {
    console.log(args);
    const startDate1 = args.value[0];
    const endDate1 = args.value[1];
    const startDate2 = moment(startDate1).format("YYYY-MM-DD");
    const endDate2 = moment(endDate1).format("YYYY-MM-DD");
    setStartDate(startDate2);
    setEndDate(endDate2);
    setSelectedOption("");
  };
  const handleDateRangePickerRef = (ref) => {
    if (ref && selectedOption === "custom") {
      ref.show();
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    if (value === "1week") {
      oneWeekHandler();
      setShowDatePicker(false);
    } else if (value === "1day") {
      oneDayHandler();
      setShowDatePicker(false);
    } else if (value === "1month") {
      oneMonthHandler();
      setShowDatePicker(false);
    } else if (value === "1year") {
      oneYearHandler();
      setShowDatePicker(false);
    } else if (value === "custom") {
      setShowDatePicker(true);
    }
  };
  const oneWeekHandler = () => {
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(7, "day").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const oneMonthHandler = () => {
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(1, "month").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const oneDayHandler = () => {
    setSelectedOption("1day");
    const today = moment().startOf("day").toDate();
    setStartDate(today);
    setEndDate(today);
  };

  const oneYearHandler = () => {
    setSelectedOption("1year");

    const startDate = moment().subtract(1, "year").toDate();
    const endDate = moment().toDate();
    setStartDate(startDate); // Set start date 1 year ago
    setEndDate(endDate); // Set end date to end of this year
  };
  useEffect(() => {
    const startDate1 = moment(startDate).format("YYYY-MM-DD");
    const endDate1 = moment(endDate).format("YYYY-MM-DD");
    setDates1(startDate1.toLocaleString());
    setDates2(endDate1.toLocaleString());
  });

  const exportData = () => {
    setIsLoading(true);
    axios
      .get(
        `/export_data?created_on_start=${moment(startDate).format(
          "YYYY-MM-DD"
        )} 00:00:00&created_on_end=${moment(endDate).format(
          "YYYY-MM-DD"
        )} 23:59:59`,
        {
          headers: { accessToken: localStorage.accessToken },
        }
      )
      .then((response) => {
        setIsLoading(false);
        // console.log(response);
        if (response.data.message) {
          setShowModal(true);
          handleDownload();
        }
        console.log(response.data.message);
      })

      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const handleDownload = () => {
    const attemptDownload = () => {
      setIsLoading(true);
      axios
        .get(
          `/download_data?adminId=${localStorage.doctorId.toLowerCase()}&created_on_start=${moment(
            startDate
          ).format("YYYY-MM-DD")} 00:00:00&created_on_end=${moment(
            endDate
          ).format("YYYY-MM-DD")} 23:59:59`,
          {
            headers: { accessToken: localStorage.accessToken },
            responseType: "blob",
          }
        )
        .then((response) => {
          console.log(response);
          const data = response.data
          setData(data)
          const contentType = response.headers["content-type"];
          setContentType(contentType)

          if (response.status === 200) {
            setIsLoading(false);
            setShowButton(true);
          } 
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error downloading the file:", error.response.status);
          if (error.response.status === 400) {
            setTimeout(attemptDownload, 3000);
          } else if (error.response.status === 403) {
            NotificationManager.error(
              "Patients do not exist in this date range. Download not available",
              error.response.data.message,
              8000
            );
            setShowModal(false);
          }
        });
    };

    attemptDownload();
  };

  const excelDownload = () => {
    if (contentType && contentType.includes("application/json")) {
      const reader = new FileReader();
      reader.onload = () => {
        const jsonResponse = JSON.parse(reader.result);
        var today = new Date();
        var date =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate();
        const fileName = localStorage.doctorId + "-(" + date + ").xlsx";
        const link = document.createElement("a");
        link.href = jsonResponse.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      };
      reader.readAsText(data);
      NotificationManager.success("Success", "File Downloaded", 5000);
      setShowButton(false);
      setShowModal(false);
    }
  };


  return (
    <div className="dialog">
      {showButton ? (
        <>
        <div style={{display:'flex', gap:'10px', marginTop:'12px', alignItems:'center'}}>
        <p>Data has been exported.</p>
        <button onClick={excelDownload} className="download-button-container" style={{color:'white', width:'250px'}}>Click here to download the data</button>
        </div>
          
        </>
      ) : (
        <>
          {showModal && (
            <div>
              <p>
              The export process has started and may take a few minutes to complete.
              Please wait.
              </p>
            </div>
          )}
          {!showModal && (
            <>
              <div className="dialog__header">Filter Export Data</div>

              <div className="dialog__exportdates">
                <div
                  className="dateSelection"
                  style={{ width: "350px", marginLeft: "0px", height: "30px" }}
                >
                  <select
                    className="selectDate"
                    id="duration"
                    value={selectedOption}
                    onChange={handleChange}
                  >
                    <option>Date Range</option>
                    <option value="1day">1 Day</option>
                    <option value="1week">1 Week</option>
                    <option value="1month">1 Month</option>
                    <option value="1year">1 Year</option>
                    <option value="custom" key="">
                      Custom
                    </option>
                  </select>

                  {showDatePicker && (
                    <div className="dateRangePicker">
                      <DateRangePickerComponent
                        id="daterangepicker"
                        placeholder="Select a range"
                        startDate={startDate}
                        endDate={endDate}
                        showClearButton={false}
                        onChange={handleRangeSelected}
                        ref={(ref) => handleDateRangePickerRef(ref)}
                        cssClass="custom-daterangepicker"
                      />
                    </div>
                  )}
                  <div className="dates-container">
                    <p className="dates">
                      {moment(dates1).format("DD-MM-YYYY")}
                    </p>
                    <p className="dates">to</p>
                    <p className="dates">
                      {moment(dates2).format("DD-MM-YYYY")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="d-grid buttons justify-content-around">
                {isLoading ? (
                  <div
                    className="btn primary-button"
                    style={{
                      width: "100px",
                      textAlign: "center",
                      paddingTop: "15px",
                    }}
                  >
                    <ClipLoader color="white" size={20} />
                  </div>
                ) : (
                  <button
                    className="btn primary-button"
                    style={{ width: "100px" }}
                    onClick={exportData}
                  >
                    Export Data
                  </button>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
